<template>
 <router-link :to="route" class="menu-buttonPass" aria-label="player pass">
  <div class="menu-iconWrapper">
    <img src="@/assets/token.png" alt="Token Icon" class="menu-iconToken" />
  </div>
  <div class="text-wrapper">
    <div class="menu-textPass">Player Pass</div>
    <div class="menu-textPassSub">Tier: {{ ppTier }}</div>
  </div>
</router-link>

</template>
  
  <script>
export default {
  name: 'MenuButtonPass',
  props: {
    icon: {
      type: String,
      default: '',
    },
    ppTier: {
      type: String,
      required: true,
    },
    route: {
      type: String,
      required: true,
    },
  },
}
</script>
  
  <style scoped>
.menu-buttonPass {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--button-hover-color);
  color: var(--button-text-color);
  text-decoration: none;
  border-radius: var(--radius-regular);
  width: 100%;
  height: calc(var(--menu-button-height) * 8 / 10);
  font-size: var(--font-size-regular);
  font-weight: 500;
  cursor: pointer;
  transition: background 0.3s ease;
  animation: pulseButton 1.5s infinite;
  transition: transform 0.2s ease;
}

.menu-buttonPass:hover {
  background-color: var(--button-hover-color);
}

.menu-iconWrapper {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.menu-iconToken {
  height: 80%;
  width: auto;
  aspect-ratio: 1 / 1;
  object-fit: contain;
}


.menu-iconPass {
  font-size: var(--font-size-menuIcon);
  margin-bottom: var(--padding-tiny); 
  color: var(--button-text-color);
}

.menu-textPass {
  font-size: calc(var(--font-size-menuIcon) * 6 / 10);
  font-weight: 500;
  /* padding-left: var(--padding-tiny); */
}

.menu-textPassSub {
  font-size: calc(var(--font-size-menuIcon) * 3 / 10);
  font-weight: 200;
  /* padding-left: var(--padding-tiny); */
}

.text-wrapper {
  display: flex;
  flex-direction: column;
  line-height: 1.2;
  padding-left: var(--padding-regular);
  padding-bottom: var(--radius-tiny);
}
</style>
  